import pushModel from "@/mixin/store/api/pushModel";

export default {
    actions: {
        fetchSaleDailyStat(context, data = null) {
            if (!context.state.saleDaily.isNeedFetch) {
                return
            }

            if (data === null) {
                data = {dateFrom: null, dateTo: null}
            }

            return pushModel(context, 'sale_dailies/stat', data, 'updateSaleDaily')
        }
    },
    mutations: {
        updateSaleDaily(state, data) {
            state.saleDaily.models = data
            state.saleDaily.isNeedFetch = false
        }
    },
    state: {
        saleDaily: {
            models: [],
            isNeedFetch: true
        }
    },
    getters: {
        getSaleDaily(state) {
            return state.saleDaily.models
        }
    }
}
